import {Redirect} from "react-router-dom";
import React, {useEffect, useState} from "react";

import {useTunnelData} from "../TunnelContext";
import OfferSelect from './OfferSelect';
import ProductsLoader from '../ProductsLoader';
import LoadingScreen from "../components/LoadingScreen";

export default function Plans() {
	return <ProductsLoader><PlansChoice/></ProductsLoader>
}

function PlansChoice() {
	const [step, setStep] = useState("OFFER");
	const [errorMsg, errorMsgSet] = useState(false);

	const {tunnel} = useTunnelData();

	useEffect(() => {
		window.scrollTo(0, 0)
	}, []);


	if (!tunnel.club )
		return <Redirect push to={'/'}/>

	const {plans, options} = tunnel.products;
	if( !plans.length ) {
		return (
			<p>Pas d'abonnements trouvés</p>
		); 
	}

	if (step === "USER") {
		return <Redirect push to={'/user'} />;
	}

	let nextStep = () => { throw new Error('No next step') };
	if( step === 'OFFER') {
/* 		if (options?.length )
			nextStep = () => setStep('OPTIONS');
		else */
			nextStep = () => setStep('USER');
	} else if ( step === 'OPTIONS') {
		nextStep = () => setStep('USER');
	} else if ( step === 'CREATE' ) {
		//There is no nextStep for this
	} else if ( step === 'SEPA' ) {
		//There is no nextStep for this
	} else {
		console.warn('Cannot create nextStep for step ===', step);
	}

	if( step === 'OFFER') {
		return <OfferSelect plans={plans} goNext={ nextStep } errorMsg={errorMsg} errorMsgSet={errorMsgSet} />
	}

	if (step === "CREATE") {
		return <p>Creation en cours</p>
	}

	if (step === "SEPA")
		return <Redirect push to={'/sepa'} />;

	console.error('What to do with step', step)
	return null;
};
